/** @format */

import React from 'react'

import {Checkbox} from '@src/components/tailwind/CheckboxV2'

import {SelectionCell} from './SelectionCell'
import {useSubmissionsContext} from './SubmissionsContext'

type EmptyTableProps = {
  columnSizeVars: Record<string, string>
}

export function EmptyTable(props: EmptyTableProps) {
  const {columnSizeVars} = props
  const {filter, pagination, search} = useSubmissionsContext()
  const text =
    filter.folder === 'spam'
      ? 'No submission flagged as spam yet.'
      : filter.folder === 'overlimit'
        ? 'No over-limit submissions.'
        : pagination.pageIndex === 0
          ? !!search
            ? 'No submissions matching your query'
            : "You haven't submitted this form yet."
          : !!search
            ? 'No submissions matching your query'
            : 'No submissions found in this range.'
  return (
    <div className="max-w-full overflow-x-auto" style={columnSizeVars}>
      <div className="flex">
        <SelectionCell className="border-b">
          <Checkbox />
        </SelectionCell>
        <div className="flex flex-none grow justify-center border-b border-gray-100 px-4 py-2">
          <span className="whitespace-nowrap text-xs font-medium text-gray-700">
            _date
          </span>
        </div>
      </div>

      {Array.from({length: 10}, (_, i) => (
        <div className="flex" key={i}>
          <SelectionCell>
            <div className="h-4 w-4" />
          </SelectionCell>
          <div className="grow px-4 py-2 text-center">
            {i === 4 ? text : null}
          </div>
        </div>
      ))}
    </div>
  )
}
